import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tripCard" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "tripCard__link" }, null, -1)
const _hoisted_3 = { class: "tripCard__title" }
const _hoisted_4 = { class: "tripCard__params" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, " Название: ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " Компания: ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, " Агент: ", -1)
const _hoisted_8 = { class: "tripCard__price" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, "Командировка №" + _toDisplayString(_ctx.item.businessTripId), 1),
    _createVNode("ul", _hoisted_4, [
      _createVNode("li", null, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.item.name), 1 /* TEXT */)
      ]),
      _createVNode("li", null, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.item.clientName), 1 /* TEXT */)
      ]),
      _createVNode("li", null, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.item.agentName), 1 /* TEXT */)
      ])
    ]),
    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.item.totalCost ? _ctx.item.totalCost + " ₽" : "Список заказов пуст"), 1)
  ]))
}